import React from "react";
import {connect} from "react-redux";
import moment from "moment";
import {TaggedLogger} from "@nextlot/core/utilities";
import {AuctionsManager} from "@nextlot/core/webcast";
import type {ChatRoom} from "@nextlot/core/webcast/data/data_types_definitions";
import NetworkAwareBusyOverlayCmp from "../NetworkAwareBusyOverlayCmp";
import {useTranslation} from "react-i18next";
import {ReduxActiveWebcastSubStateType} from "@nextlot/core/webcast/redux/reducerActiveWebcast";
import useIntersectionObserver from '@react-hook/intersection-observer';
import {ChannelEnum} from "@nextlot/core/webcast/redux/actions";
import NextLotJSDATA from "@nextlot/core/NextLotJSDATA";


const _logger = TaggedLogger.get('BidderChatBoxCmp');

function BidderChatBoxCmp(props) {
    // _logger.debug('.render()', props);

    const { t, i18n } = useTranslation();

    const refMessagesListBottom = React.useRef<HTMLDivElement>();
    const [myUserId, setMyUserId] = React.useState<number>(AuctionsManager.currentWebcastAuctionHandler.auctionConnectData.participantId);
    const [currentChatMessageText, setCurrentChatMessageText] = React.useState<string>('');

    const [refChatBox, setRefChatBox] = React.useState<HTMLDivElement>();
    const {isIntersecting} = useIntersectionObserver<HTMLDivElement>(refChatBox, {threshold: 0.25});

    function renderChatMessageListItem(chatMsg) {
        const direction = chatMsg.sender === props.chat.myUserInfo.senderUserId ? 'ours' : 'theirs';

        return (
            <div key={[chatMsg.timestamp, chatMsg.sender].join('-')}
                 className={`messages-list__list-item ${direction}`}>
                <div className="body-text">{chatMsg.body}</div>
                <div className="time-label">{moment.utc(chatMsg.timestamp).local().format('h:mma')}</div>
            </div>
        )
    }

    const _handleFormSubmit_ChatMessageForm = (event) => {
        event.preventDefault();
        AuctionsManager.currentWebcastAuctionHandler.controller.sendChatMessage(myUserId, currentChatMessageText);

        setCurrentChatMessageText('');
    };

    const _handleChange_ChatMessageInput = (event) => {
        setCurrentChatMessageText(event.target.value);
    };

    const _handle_ChatBubbleClick = () => {
        scrollMessagesListToBottom();
    }

    const scrollMessagesIfVisible = () => {
      isIntersecting && scrollMessagesListToBottom();
    }

    const scrollMessagesListToBottom = () => {
        refMessagesListBottom.current && refMessagesListBottom.current.scrollIntoView({ behavior: 'auto' });
    };

    // Triggered when:
    // - on first render while on Desktop/Wide screens
    // - click/tap on the Chat bubble while on Mobile view
    React.useEffect(() => {
      scrollMessagesIfVisible();
      AuctionsManager.currentWebcastAuctionHandler.controller.openChatRoomAndMarkAsRead(myUserId);
    }, [isIntersecting]);

    React.useEffect(() => {
      scrollMessagesIfVisible();
    });


    const myChatRoom: ChatRoom = props.chat.chatRoomsById.get(props.chat.activeChatRoomId);


    if ( ! myChatRoom) {
        return <div>{t('chat.loading')}</div>
    }

    return (

        <React.Fragment>
        <div ref={setRefChatBox} className="bidder-chat-outline">

            <NetworkAwareBusyOverlayCmp wbsCommChannel={ChannelEnum.chat} />

            <div className="bidder-cmp bidder-cmp--chat">
                <h5 className="cmp__header">
                    {t('chat.header')}
                </h5>
                <div className="cmp__body">
                    <div className="messages-list-container">
                        <div className="messages-list__scrollable-container">
                            {
                                NextLotJSDATA.bidder_notification_sms_auction_timeline_enabled_for_current_auction &&
                                renderChatMessageListItem({
                                    "body": "Now Available! - Watch Lots to Receive a Text Message 10 Lots Before Your Lot Sells",
                                    "sender": 0,
                                    "timestamp": new Date().getTime()
                                })
                            }
                            {myChatRoom.messages.map(chatMsg => renderChatMessageListItem(chatMsg))}
                            <div ref={refMessagesListBottom} style={{ fontSize: 2 }}>&nbsp;</div>
                        </div>
                    </div>

                    <form onSubmit={_handleFormSubmit_ChatMessageForm} className="p-0 pt-1 d-flex flex-row">
                        <input type='text' className='w-100 me-1' onChange={_handleChange_ChatMessageInput}
                               value={currentChatMessageText}/>
                        <button type="submit" className='btn btn-outline-primary btn-sm'
                                disabled={!currentChatMessageText}>{'\u27a4'}
                        </button>
                    </form>
                </div>
            </div>

        </div>

        {
          !isIntersecting && myChatRoom.unreadCount > 0 &&
          <div className="bidder-chat-bubble-outline" onClick={_handle_ChatBubbleClick}>
            <div className="bidder-cmp-chat-bubble">
              <div className="bidder-cmp-chat-bubble-total-messages">
                <i className="fa-regular fa-message-lines fa-lg"></i>
                <span className="total-messages">{myChatRoom.unreadCount}</span>
              </div>
            </div>
          </div>
        }

        </React.Fragment>

    )
}

export default connect(({ activeWebcast }: {activeWebcast:ReduxActiveWebcastSubStateType}) => {
    return {
        webcastStatus: activeWebcast.webcastStatus,
        chat: activeWebcast.webcastChat,
    };
})(BidderChatBoxCmp);

